import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { useSettings } from '../SettingsContext';
import axios from "axios";

const Header = () => {
    const setting = useSettings();
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaTypes, setVisaTypes] = useState([]);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        // Check if visa types data is available in localStorage
        const cachedData = JSON.parse(localStorage.getItem('visaTypesData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            // Check if the cached data has expired (older than 30 minutes)
            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                // If not expired, use the cached data
                setVisaTypes(data);
            } else {
                // If expired, clear the cache and fetch new data
                localStorage.removeItem('visaTypesData');
                fetchVisaTypes();
            }
        } else {
            // If no cache, fetch data from the API
            fetchVisaTypes();
        }
    }, []);

    const fetchVisaTypes = () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;

        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => {
                const newData = response.data;
                // Save the fetched data along with the current timestamp in localStorage
                localStorage.setItem('visaTypesData', JSON.stringify({
                    data: newData,
                    timestamp: Date.now(),
                }));
                setVisaTypes(newData);
            })
            .catch(error => {
                console.error("Error fetching API", error);
            });
    };

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header>
            <div className="header-top text-white" style={{backgroundColor: '#1C4ABE'}}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xxl-8 col-lg-6">
                            <div className="header-top-left pt-2">
                                <ul>
                                    <li><span className={'text-white fw-bold'}>Open Time :</span> <span className={'text-white fw-bold'}>{setting?.office_hour}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-lg-6">
                            <div className="topheader-info">
                                <div className="header-location">
                                    <ul className="d-flex align-items-center gap-3 list-unstyled mb-0" style={{ justifyContent: 'flex-end' }}>
                                        {[
                                            { key: 'facebook', icon: 'fab fa-facebook-f', label: 'Facebook' },
                                            { key: 'youtube', icon: 'fab fa-youtube', label: 'YouTube' },
                                            { key: 'instagram', icon: 'fab fa-instagram', label: 'Instagram' },
                                            { key: 'tiktok', icon: 'fab fa-tiktok', label: 'TikTok' },
                                            { key: 'twitter', icon: 'fab fa-x-twitter', label: 'Twitter / X' },
                                        ].map(
                                            (social) =>
                                                setting?.[social.key] && (
                                                    <li key={social.key}>
                                                        <a
                                                            href={setting[social.key]}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            aria-label={social.label}
                                                            className="social-link"
                                                        >
                                                            <i className={`${social.icon} text-white`}></i>
                                                        </a>
                                                    </li>
                                                )
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="header-menu header-sticky">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-8">
                            <div className="header-logo ">
                                <Link className="navbar-brand" to={'/'}>
                                    <img style={{width:'125px'}} src={`${backendBaseUrl}${setting?.logo}`} alt="logo" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xxl-8 col-xl-8 col-lg-8 col-4 d-flex align-items-lg-center justify-content-end justify-content-lg-start">
                            <div className="main-menu d-none d-lg-block fw-bold">
                                <nav id="mobile-menu">
                                    <ul>
                                        <li className="">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/"
                                            >
                                                HOME
                                            </NavLink>
                                        </li>
                                        <li className="">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/about-us"
                                            >
                                                ABOUT US
                                            </NavLink>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                data-bs-toggle="dropdown"
                                                onClick={(e) => e.preventDefault()}
                                                style={{ pointerEvents: 'none', cursor: 'default' }}
                                            >
                                                VISA
                                            </NavLink>
                                            <ul className="sub-menu">
                                                <li>
                                                    <Link className="dropdown-item" to={'/visa'}>All Visa</Link>
                                                </li>
                                                {visaTypes.map((visaType, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <Link className="dropdown-item text-wrap" to={`/visa/${visaType.slug}`}>
                                                                {visaType?.name}
                                                            </Link>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </li>
                                        <li className="">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/blogs"
                                            >
                                                BLOGS
                                            </NavLink>
                                        </li>
                                        <li className="">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/faqs"
                                            >
                                                FAQ
                                            </NavLink>
                                        </li>
                                        {/*<li>
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/contact-us"
                                            >
                                                Contact Us
                                            </NavLink>
                                        </li>*/}
                                        <li>
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/gallery"
                                            >
                                                Gallery
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/training"
                                            >
                                                Training & Skill
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/career"
                                            >
                                                Career
                                            </NavLink>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="side-menu-icon d-lg-none text-end">
                                <button className="side-toggle" onClick={() => setIsMenuOpen(true)}>
                                    <i className="far fa-bars"></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-2 d-none d-lg-block">
                            <div className="main-menu-wrapper d-flex align-items-center justify-content-end">
                                <div className="main-menu-wrapper__call-number d-flex align-items-center">
                                    <div className="main-menu-wrapper__call-icon mr-10">
                                        <img src="assets/img/menu-icon/chatting.png" alt=""/>
                                    </div>
                                    <div className="main-menu-wrapper__call-text">
                                        <span className={'fs-6'}>Call Us</span>
                                        <h5 className={'pt-1'}><a className={'nav-link'}>{setting?.header_phone}</a></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Fixed Overlay with inline style support to ensure click works */}
            <div
                className={`offcanvas-overlay ${isMenuOpen ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 99999,
                    visibility: isMenuOpen ? 'visible' : 'hidden',
                    opacity: isMenuOpen ? 1 : 0,
                    transition: 'all 0.3s ease-in-out'
                }}
            ></div>

            <div
                className={`d-lg-none side-info ${isMenuOpen ? 'info-open' : ''}`}
                onClick={(e) => e.stopPropagation()}
                style={{ zIndex: 100000 }}
            >
                <button className="side-info-close" onClick={() => setIsMenuOpen(false)}>
                    <i className="fal fa-times"></i>
                </button>
                <div className="side-info-content">
                    <div className="header-logo bg-white p-3">
                        <Link className="navbar-brand" to={'/'} onClick={() => setIsMenuOpen(false)}>
                            <img style={{width:'140px'}} src={`${backendBaseUrl}${setting?.logo}`} alt="logo" />
                        </Link>
                    </div>
                    <ul>
                        <li><NavLink className={'nav-link text-white my-3'} to="/" onClick={() => setIsMenuOpen(false)}>HOME</NavLink></li>
                        <li><NavLink className={'nav-link text-white my-3'} to="/about-us" onClick={() => setIsMenuOpen(false)}>ABOUT US</NavLink></li>
                        <li className="menu-item-has-children">
                            <NavLink className={'nav-link text-white my-3'} to="/visa" onClick={() => setIsMenuOpen(false)}>VISA</NavLink>
                            <ul>
                                <li><NavLink className={'nav-link text-white my-3'} to="/visa" onClick={() => setIsMenuOpen(false)}>All Visa</NavLink></li>
                                {visaTypes.map((visaType, index) => (
                                    <li key={index}>
                                        <NavLink className={'nav-link text-white my-3'} to={`/visa/${visaType.slug}`} onClick={() => setIsMenuOpen(false)}>{visaType.name}</NavLink>
                                    </li>
                                ))}
                            </ul>
                        </li>
                        <li><NavLink className={'nav-link text-white my-3'} to="/blogs" onClick={() => setIsMenuOpen(false)}>NEWS & ARTICLE</NavLink></li>
                        <li><NavLink className={'nav-link text-white my-3'} to="/faqs" onClick={() => setIsMenuOpen(false)}>FAQS</NavLink></li>
                        <li><NavLink className={'nav-link text-white my-3'} to="/contact-us" onClick={() => setIsMenuOpen(false)}>CONTACT US</NavLink></li>
                        <li>
                            <NavLink
                                className={'nav-link text-white my-3'}
                                to="/gallery"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                GALLERY
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                className={'nav-link text-white my-3'}
                                to="/career"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Career
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default Header;